'use strict'
module.exports = {
  //todo api服务器
  apiConfig:{
    /*本地接口路径*/
    // host:"http://127.0.0.1",
    // port:8089
    // host:"http://epp.test.yzbays.cn",
    // port:80
    // host:"https://epp.yzstc.cn",
    // port:443
    // host:"https://epp.yzstc.cn",
    // port:80
    // http
    // host:"http://epp.yazhou-bay.com",
    // port:80
    // https
    host:"https://epp.yazhou-bay.com",
    port:443
    // host:"http://47.99.85.203",
    // port:8084
  },

  //todo web服务器
  webConfig:{
    host:'0.0.0.0',
    port:8088
  },
  //todo 文件服务器
  fileHost:'http://101.37.30.92:8899',

};



//////////////////
// WEBPACK FOOTER
// ./server.config.js
// module id = nj+h
// module chunks = 77